// extracted by mini-css-extract-plugin
module.exports = {"wrap":"vmI596w11R488PgxaYIMZ","bottomHalf":"_3Vd6R_affyPm942cR_pXk8","topHalf":"_2tREN2ZHy9GJzjU2a9aLaH","info":"_2wohsq0vbqt9CGAHJTbA4P","title":"_1zirkXbNOsRxlRHqfAAhu7"};